<!-- FORM FIELDS -->
<p-panel>    
    <div class="row">
        <div class="col">

            @if (!formReady) {
                <div class="d-flex justify-content-center align-items-center" style="min-height: 300px;">
                    <p-progressSpinner 
                        strokeWidth="4" 
                        [style]="{width: '60px', height: '60px'}"
                        animationDuration=".8s">
                    </p-progressSpinner>
                </div>
            }

            @if (formReady) {
                <app-reactive-form-builder
                    (formChanges)="formChanges($event[0], $event[1])"
                    (goBack)="goBack()"
                    [form]="form.formFields"
                    [serverUrl]="env.auxServerUrl"
                    [dropdownLoadTrigger]="dropdownLoadTrigger"
                    [debug]="debugFitosanitariosForm"
                    [previousData]="previousDataLoaded"
                    [request]="this.getType() === 1 ? this.tareasApi.fitosanitariosPUT : this.tareasApi.fitosanitariosPOST"
                    [getRequest]="this.tareasApi.fitosanitariosGET"
                    (afterSend)="onAfterSend($event)"
                    >
                </app-reactive-form-builder>
            }

        </div>     
    </div>
</p-panel>

<p-dialog [visible]="form.showDialogTratamiento()" (onHide)="productsTratamientos = []" (onShow)="getDataProducts()" [modal]="true" [style]="{width: '80vw'}" [closable]="false" (onHide)="form.showDialogTratamiento.set(false)">
    <ng-template pTemplate="header">
        <div class="d-flex justify-content-left align-content-center">
            <div>
                <h4>Productos fitosanitarios</h4>
            </div>
        </div>
    </ng-template>

    <ng-template pTemplate="content">
        <table class="table table-striped">
            <thead>
                <tr class="table-dark">
                    <th></th>
                    <th>Producto</th>
                    <th>Uso</th>
                    <th>Agente</th>
                    <th>Dosis Min.</th>
                    <th>Dosis Max.</th>
                    <th>Vol. Caldo</th>
                    <th>N° Máx. Aplicaciones</th>
                    <th>Composición</th>
                    <th>Condiciones de uso</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let producto of productsTratamientos; let i = index">
                    <td style="width: 40px; text-align: center;">
                        {{i + 1}}
                    </td>
                    <td>{{producto.nombre_comercial}}</td>
                    <td>{{producto.uso}}</td>
                    <td>{{producto.dosis_min}} {{producto.unidades}}</td>
                    <td>{{producto.dosis_max}} {{producto.unidades}}</td>
                    <td>
                        {{producto.vol_caldo_min ?? 'N/A'}} -
                        {{producto.vol_caldo_max ?? 'N/A'}}
                    </td>
                    <td>{{producto.n_aplicaciones}}</td>
                    <td>{{producto.composicion}}</td>
                    <td>{{producto.condiciones_uso}}</td>
                </tr>
            </tbody>
        </table>
    </ng-template>

    <ng-template pTemplate="footer">
        <button pButton severity="primary" type="button" label="Cerrar" icon="pi pi-times" (click)="form.showDialogTratamiento.set(false)"></button>
    </ng-template>
</p-dialog>